import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';


const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _entities = [];
let _stats = {};
let _fetchedAll = false;

const FilterStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return {remove: () => this.removeChangeListener(callback) };
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _entities;
    },
    getList: function() {
        return _entities
            .filter(function(e) { return e !== undefined; })
            .map(function(e) { return {} });
    },
    getById: function(id) {
        var entity = _entities.filter(function(entity) {
            return entity.id == id;
        });
        return entity.pop();
    },
    add: function(event) {
        // check if the event already exists in the collection
        var index = _entities.findIndex(function(elem, i) {
            return elem !== undefined && elem.id == event.id;
        });
        // remove element if already exists
        if(index >= 0) {
            delete _entities[index];
        }
        _entities.push(event);
    },
    update: function(event) {
        _entities[event.id] = event;
    },
    delete: function(id) {
        delete _entities[id];
    },
    getStats: function() {
        return _stats;
    },
    fetchedAll: () => (_fetchedAll)

});

FilterStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.FILTER_LIST:
            if (action.data.length === 0) {
                _fetchedAll = true;
            } else {
                action.data.forEach(FilterStore.add);
                _fetchedAll = false;
            }
            FilterStore.emitChange();
            break;

        case ActionTypes.FILTER_LIST_ERROR:
            FilterStore.emitChange();
            break;

        case ActionTypes.FILTER_INFO:
            FilterStore.add(action.data);
            FilterStore.emitChange();
            break;

        case ActionTypes.FILTER_INFO_ERROR:
            FilterStore.emitChange();
            break;

        case ActionTypes.FILTER_UPDATE:
            FilterStore.update(action.data);
            FilterStore.emitChange();
            break;

        case ActionTypes.FILTER_DELETE:
            FilterStore.delete(action.data);
            FilterStore.emitChange();
            break;

        case ActionTypes.FILTER_SAVE:
            FilterStore.add(action.data);
            FilterStore.emitChange();
            break;

        default:
            break;

    }

});

export default FilterStore;
